import { createEvent, createStore, sample } from 'effector';
import { $resetAuth } from './profile-entity';

export interface IMyCode {
	id: number;
	clientId: string;
	buildId: string;

	sender: string;
	text: string;
	code?: string;

	createdAt: number;
}

export const $resetPanelState = createEvent();

export const $setMyCodes = createEvent<IMyCode[]>();
export const $addMyCode = createEvent<IMyCode>();

export const $myCodes = createStore<IMyCode[]>([])
	.on($setMyCodes, (_, payload) => payload)
	.on($addMyCode, (state, payload) => [payload, ...state])
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
